declare global {
    var VisualiserConfig: {
        assetPath: string;
        locale: 'au' | 'us';
    };
}

export enum FrameColour {
    PureWhite = 'WH',
    SurfMist = 'SM',
    ClassicCream = 'CC',
    Paperbark = 'PB',
    WoodlandGrey = 'WG',
    Monument = 'MN',
    Bronze = 'BZ',
    Black = 'BK',
}

export enum BlindPosition {
    Open = 0,
    Closed = 1,
}

export enum FabricTone {
    Light = 4,
    Dark = 8,
}

export enum IndoorOutdoor {
    Outdoor = 0,
    Indoor = 2,
}

export enum TimeOfDay {
    Day = 1,
    Night = 2,
}
